import { onMount, onDestroy } from '@/modules/_'

export default function (element, dataset) {
  console.log('Highlighted text initializing')
  const initHighlightText = () => {
    if (
      typeof gsap === 'undefined' ||
      typeof SplitText === 'undefined' ||
      typeof ScrollTrigger === 'undefined'
    )
      return

    gsap.registerPlugin(ScrollTrigger, SplitText)

    const splitHeadingTargets = element.querySelectorAll('.h3')
    splitHeadingTargets.forEach((heading) => {
      const scrollStart =
        heading.getAttribute('data-highlight-scroll-start') || 'top 90%'
      const scrollEnd =
        heading.getAttribute('data-highlight-scroll-end') || 'center 40%'
      const fadedValue =
        parseFloat(heading.getAttribute('data-highlight-fade')) || 0.2
      const staggerValue =
        parseFloat(heading.getAttribute('data-highlight-stagger')) || 0.1

      new SplitText(heading, {
        type: 'words, chars',
        autoSplit: true,
        onSplit(self) {
          const ctx = gsap.context(() => {
            gsap
              .timeline({
                scrollTrigger: {
                  scrub: true,
                  trigger: heading,
                  start: scrollStart,
                  end: scrollEnd,
                },
              })
              .from(self.chars, {
                autoAlpha: fadedValue,
                stagger: staggerValue,
                ease: 'linear',
              })
          }, heading)
          return ctx
        },
      })
    })
  }

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      initHighlightText()
    })
  })
}
